import React from "react";
import { Popup } from "react-map-gl";
import {
  StyledPopup,
  PopupHeader,
  PopupTitle,
  PopupContent,
} from "../Popup/styled";

function DistrictPopup({
  className,
  data,
  children,
  showDetails = true,
  showClose = true,
  ...props
}) {
  return (
    <StyledPopup
      className={className}
      {...props}
      $showDetails={showDetails}
      as={Popup}
    >
      <PopupHeader>
        <PopupTitle>{data.school_dis}</PopupTitle>
      </PopupHeader>
      {showDetails && (
        <PopupContent>
          <ul>
            <li>
              <span>Number of Solar Schools:</span> {data.number_solar_schools}
            </li>
            <li>
              <span>Total Solar Capacity:</span>{" "}
              {data.total_solar_school_energy_capacity.toLocaleString("en-US")}{" "}
              kW
              {/* <span>Battery Storage:</span> {data.battery_storage} */}
            </li>
          </ul>
        </PopupContent>
      )}
    </StyledPopup>
  );
}

export default DistrictPopup;
